import React from 'react';
import Product from '../../Types/Product';
import { YotpoBottomLine } from '../../Types/Yotpo';
import { translate } from '../../Services/translation';
import RatingStars from '../RatingStars';
import YotpoStarsDistribution from './YotpoStarDistribution';
import {useTypedSelector} from "../../Hooks/useTypedSelector";

const YotpoReviews = ({
  product,
  bottomLine,
}: {
  product?: Product;
  bottomLine?: YotpoBottomLine;
}) => {
  const { reviewInstanceId } = useTypedSelector((state) => state.yotpo);
  return (
    <div
      id="yotpo-reviews-widget"
      className="container container--narrow"
    >
      {bottomLine !== undefined && (
        <div className="flex flex-col items-center justify-center">
          <h3 className="mb-3 font-bold">
            {bottomLine?.total_review ?? 0}{' '}
            {translate('general.reviews').toLowerCase()}
          </h3>
          {typeof bottomLine?.total_review !== 'undefined' && (
            <RatingStars
              rating={bottomLine.average_score}
              showRatingText={false}
              starClassName="!w-7 !h-7"
            />
          )}
          {bottomLine?.total_review > 0 && (
            <span className="mt-3 text-sm">
              {translate('product-page.average-score-text').replace(
                '{0}',
                bottomLine.average_score.toString()
              )}
            </span>
          )}
          {typeof bottomLine?.total_review !== 'undefined' && (
            <div className="mt-3 w-full">
              <YotpoStarsDistribution
                totalReviews={bottomLine.total_review}
                starDistribution={bottomLine.star_distribution}
              />
            </div>
          )}
        </div>
      )}
      <div
        className="yotpo-widget-instance"
        data-yotpo-instance-id={reviewInstanceId}
        data-yotpo-product-id={product?.id}
        data-yotpo-description={product?.description}
        data-yotpot-price={
            (product?.price.campaignPrice ?? product?.price.price)
                ?.priceWithVat
        }
        data-yotpo-currency={product?.price.currency.id}
        data-yotpo-name={product?.name}
        data-yotpo-url={product?.url}
        data-yotpo-image-url={
            product?.images ? product.images[0]?.originalSrc : undefined
        }
      ></div>
    </div>
  );
};

export default YotpoReviews;
